import api from '@/lib/api';
import type {
  PaginatedResponse,
  RetailAllergen,
  RetailMenuSection,
} from '@pms/shared';

// ─── Allergens (/v1/retail/allergens) ──────────────────────────────────────────
// Product-attribute lookups (TASK-66 WAVE 2, F7). ADMIN/SUPER_ADMIN only.

export interface ListAllergensQuery {
  propertyId: string;
  search?: string | undefined;
  isActive?: boolean | undefined;
}

export interface CreateAllergenPayload {
  propertyId: string;
  name: string;
  isActive?: boolean | undefined;
}

export interface UpdateAllergenPayload {
  name?: string | undefined;
  isActive?: boolean | undefined;
}

export async function fetchAllergens(
  query: ListAllergensQuery,
): Promise<PaginatedResponse<RetailAllergen>> {
  const { data } = await api.get<PaginatedResponse<RetailAllergen>>('/retail/allergens', {
    params: query,
  });
  return data;
}

export async function createAllergen(
  payload: CreateAllergenPayload,
): Promise<RetailAllergen> {
  const { data } = await api.post<RetailAllergen>('/retail/allergens', payload);
  return data;
}

export async function updateAllergen(
  id: string,
  payload: UpdateAllergenPayload,
): Promise<RetailAllergen> {
  const { data } = await api.patch<RetailAllergen>(`/retail/allergens/${id}`, payload);
  return data;
}

export async function deleteAllergen(id: string): Promise<void> {
  await api.delete(`/retail/allergens/${id}`);
}

// ─── Menu sections (/v1/retail/menu-sections) ───────────────────────────────────

export interface ListMenuSectionsQuery {
  propertyId: string;
  search?: string | undefined;
  isActive?: boolean | undefined;
}

export interface CreateMenuSectionPayload {
  propertyId: string;
  name: string;
  sortOrder?: number | undefined;
  isActive?: boolean | undefined;
}

export interface UpdateMenuSectionPayload {
  name?: string | undefined;
  sortOrder?: number | undefined;
  isActive?: boolean | undefined;
}

export async function fetchMenuSections(
  query: ListMenuSectionsQuery,
): Promise<PaginatedResponse<RetailMenuSection>> {
  const { data } = await api.get<PaginatedResponse<RetailMenuSection>>(
    '/retail/menu-sections',
    { params: query },
  );
  return data;
}

export async function createMenuSection(
  payload: CreateMenuSectionPayload,
): Promise<RetailMenuSection> {
  const { data } = await api.post<RetailMenuSection>('/retail/menu-sections', payload);
  return data;
}

export async function updateMenuSection(
  id: string,
  payload: UpdateMenuSectionPayload,
): Promise<RetailMenuSection> {
  const { data } = await api.patch<RetailMenuSection>(`/retail/menu-sections/${id}`, payload);
  return data;
}

export async function deleteMenuSection(id: string): Promise<void> {
  await api.delete(`/retail/menu-sections/${id}`);
}
